import React from 'react'
import PropTypes from 'prop-types'

import AdCardListItem from '../../../../../../features/components/AdCardListItem'

import AdCardDetails from '../../../../../../features/components/AdCardListItem/AdCardDetails'
import OnsiteAdCardMetrics from './OnsiteAdCardMetrics'

import useStyles from './styles'

function OnsiteAdCardListItem({ onsiteAd }) {
  const classes = useStyles()

  const { campaign_name: campaignName, name, clicks, impressions, file_url: fileUrl } = onsiteAd

  return (
    <AdCardListItem>
      <img className={classes.onsiteAdPreview} src={fileUrl} alt="" />
      <AdCardDetails title={name} subTitle={campaignName} />

      <OnsiteAdCardMetrics metrics={{ impressions, clicks }} />
    </AdCardListItem>
  )
}

export default OnsiteAdCardListItem

OnsiteAdCardListItem.propTypes = {
  onsiteAd: PropTypes.shape({
    name: PropTypes.string.isRequired,
    campaign_name: PropTypes.string.isRequired,
    file_url: PropTypes.string.isRequired,
    clicks: PropTypes.number,
    impressions: PropTypes.number
  })
}
